import React from 'react';
import ScheduleTable from './components/ScheduleTable';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Header from './components/Header';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { UserRole } from './types/auth';
import { mapBackendRoleToFrontend } from './utils/roleUtils';

// 認証済みルート用のコンポーネント
const ProtectedRoute: React.FC<{ element: JSX.Element }> = ({ element }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  return user ? element : <Navigate to="/login" />;
};

// メインアプリケーション
const AppContent: React.FC = () => {
  const { user, loading } = useAuth();
  
  // 認証状態の読み込み中
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  // 共通ユーティリティ関数を使ってロールをマッピング
  const userRole = mapBackendRoleToFrontend(user?.role);

  return (
    <Router>
      {/* propsを削除して単純に呼び出す */}
      <Header />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/" 
          element={
            <ProtectedRoute
              element={<ScheduleTable userRole={userRole} />}
            />
          } 
        />
        {/* 他のルートをここに追加 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

// AuthProviderでラップしたアプリ
const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
